<template>
  <span v-if="!!price">
    <span v-if="displayCurrency && currency">{{ currency }}</span>
    {{ price }}
    <ListingPriceUnit
      v-if="displayPriceUnit"
      :offerType="offerType"
      :listingPriceInfo="listingPriceInfo"
    />
  </span>
  <span v-else>{{ t('ON_REQUEST') }}</span>
</template>

<script lang="ts" setup>
import { hgPrice, HgSupportedLanguage } from '@smg-real-estate/domus';
import { Buy, OfferType, Rent } from '@smg-real-estate/hg-rets-schema';

import ListingPriceUnit from '@/components/ListingPrice/ListingPriceUnit.vue';
import { HgPriceType } from '@/models/HgPriceType';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

defineOptions({
  name: 'ListingPrice',
});

export interface Props {
  currency?: string;
  offerType: OfferType;
  listingPriceInfo?: Buy | Rent;
  priceType?: string;
  displayCurrency?: boolean;
  displayPriceUnit?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  currency: undefined,
  listingPriceInfo: undefined,
  priceType: undefined,
  displayCurrency: true,
  displayPriceUnit: true,
});

const price = computed(() => {
  if (!props.listingPriceInfo) {
    return;
  }
  let displayPrice;

  switch (props.priceType) {
    case HgPriceType.NET: {
      displayPrice = (props.listingPriceInfo as Rent)?.net;
      break;
    }
    case HgPriceType.EXTRA: {
      displayPrice = props.listingPriceInfo?.extra;
      break;
    }
    default:
      displayPrice =
        (props.listingPriceInfo as Buy)?.price || (props.listingPriceInfo as Rent)?.gross;
  }
  if (!displayPrice) {
    return undefined;
  }
  return hgPrice(displayPrice, locale.value as HgSupportedLanguage);
});
</script>
